import { Flex, Grid } from '@chakra-ui/react';
import { uniqueId } from 'lodash';
import { Paragraph, TextLink } from 'ui-components';
import { IManagerApiModuleManagerBenchmark } from '~/clientApi/managers.model';
import { MetricCard } from '~/components/CreatorChannelMetrics/MetricCard';
import { SupportedPlatforms } from '~/screens/CreatorAudienceDemographics';
import { CreatorType } from '~/types';

import { getPlatformMetrics } from './utils';

interface Props {
  platform: SupportedPlatforms;
  hideLink?: boolean;
  isBuilder?: boolean;
}
export const MockMetrics: React.FC<Props> = ({
  platform,
  hideLink = false,
  isBuilder = false,
}) => {
  const mockBenchmarks: IManagerApiModuleManagerBenchmark[] = [
    {
      id: '1',
      benchmarks: {
        igFollowersCount: 6,
        igAvgImageImpressions: 1,
        igAvgImageReach: 2,
        igAvgImageEngagements: 3,
        igAvgImageLikes: 4,
        igAvgImageSaved: 5,
        igAvgImageComments: 6,
        igAvgImageFollowers: 7,
        igAvgImageFollowersEngRate: 8,
        igAvgImageReachEngRate: 9,
        igAvgVideoImpressions: 10,
        igAvgVideoReach: 11,
        igAvgVideoEngagements: 12,
        igAvgVideoLikes: 13,
        igAvgVideoSaved: 14,
        igAvgVideoComments: 15,
        igAvgVideoViews: 16,
        igAvgVideoFollowers: 17,
        igAvgVideoFollowersEngRate: 18,
        igAvgVideoReachEngRate: 19,
        igAvgVideoReachVideoViewsRate: 20,
        igAvgStoryImpressions: 3200,
        igAvgStoryReach: 3100,
        igAvgStoryTapsForward: 23,
        igAvgStoryTapsBack: 24,
        igAvgStoryReplies: 25,
        igAvgStoryExits: 26,
        igAvgStoryFollowers: 27,
        igAvgStoryFollowersReachRate: 28,
        igAvgFeedStoryImpressions: 22400,
        igAvgFeedReelsStoryReach: 22100,
        igAvgFeedReelsEngagements: 4600,
        igAvgFeedLikes: 32,
        igAvgFeedSaved: 33,
        igAvgFeedComments: 34,
        igAvgFeedFollowers: 35,
        igAvgFeedFollowerEngRate: 0.12,
        igAvgFeedReelsFollowerEngRate: 0.12,
        igAvgFeedReelsReachEngRate: 0.0211,
        igAvgReelsViewsEngRate: 0.039,
        createdAt: '2020-07-14T09:46:56.326Z',
        updatedAt: '2020-07-14T09:46:56.326Z',
        ttFollowersCount: 9,
        ttAvgViews: 1200000,
        ttAvgEngagements: 203000,
        ttAvgLikes: 198500,
        ttAvgComments: 1300,
        ttAvgShares: 3800,
        ttAvgFollowersEngRate: 0.43,
        ttAvgViewsEngRate: 0.165,
        ytAvgComments: 198500,
        ytAvgEngagements: 7,
        ytAvgLikes: 203000,
        ytAvgShares: 1300,
        ytAvgSubscribersEngRate: 3.5,
        ytAvgViewRate: 65.78,
        ytAvgViews: 1200000,
        ytAvgViewsEngRate: 0.25,
        ytFollowersCount: 2,
        combinedAudience: {
          igFollowersCount: 6,
          ttFollowersCount: 9,
          ytFollowersCount: 10,
        },
        combinedAvgEngagements: {
          igAvgEngagements: 125.01,
          ttAvgEngagements: 125.01,
          ytAvgEngagements: 66,
        },
        createdAtAgo: '',
        id: uniqueId(),
        igAvgReelsReachEngRate: 0,
        igAvgReelsInteractions: 0,
        updatedAtAgo: '',
        igAvgReelsPlaysInteractionsRate: 0,
        igAvgReelsViews: 370800,
        creator: {} as CreatorType,
        snpProfileTier: 'Snap Star',
        snpSavedStoryAvgViewTimeMs: 1000,
        snpSpotlightAvgViewTimeMs: 1000,
        snpStoryAvgViewTimeMs: 1000,
      },
    },
  ];
  const channelMetrics = getPlatformMetrics(mockBenchmarks);

  return (
    <Flex flexDirection="column" gap={4}>
      {!isBuilder ? (
        <Flex justifyContent="space-between">
          <Paragraph size="lg" fontWeight="medium">
            Talent & Channel metrics
          </Paragraph>
          {hideLink ? (
            <TextLink isDisabled={true}>Learn more about metrics</TextLink>
          ) : null}
        </Flex>
      ) : null}
      <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={4}>
        {channelMetrics[platform].map((metric) => (
          <MetricCard
            key={metric.title}
            metricTitle={metric.title}
            metricValue={metric.value}
            metricTransformValue={metric.transformValue}
            isDisabled
          />
        ))}
      </Grid>
    </Flex>
  );
};
